// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:09:21.625Z
// Property: Wyndham Crossing (ID: 6767906449167131)
// Collections: 28 amenities, 16 floorplans (live), 18 photos, 45 POIs, 1 reviews, 5 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167131",
  "property_external_id": "1110200",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/wyndham-crossing-edmonton-ab/9w2cvh5/",
  "property_google_business_url": "https://www.google.com/maps/place/Wyndham+Crossing/data=!4m2!3m1!1s0x0:0xdf14e0fc17508a75?sa=X&ved=2ahUKEwiTisuvzoOTAxXsj4kEHUz9CRYQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47723982653",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "wyndham-crossing",
  "property_name": "Wyndham Crossing",
  "property_website_url": "https://www.wyndhamcrossing.com",
  "property_domain": "https://www.wyndhamcrossing.com",
  "property_address": "4807 137th Avenue NW",
  "property_full_address": "4807 137th Avenue NW, Edmonton, AB, T5A 4A7",
  "property_address_1": "4807 137th Avenue NW",
  "property_address_2": null,
  "property_address_city": "Edmonton",
  "property_address_state": "AB",
  "property_address_zip_full": null,
  "property_address_zip": "T5A 4A7",
  "property_address_country": "CA",
  "property_address_county": "n/a",
  "property_neighborhood_address": "Sifton Park",
  "property_address_latitude": "53.5958",
  "property_address_longitude": "-113.4116",
  "property_email": "wyndhamcrossing@weidner.com",
  "property_phone": "(780) 851-9342",
  "property_call_tracking_phone": "780-851-9342",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Wyndham Crossing in Edmonton, AB, luxury meets comfort with spacious one, two, and three-bedroom apartments. Enjoy stunning views, an indoor saltwater pool, and serene walking trails—all within a pet-friendly community. Experience modern living with exclusive Shaw discounts and energy-efficient amenities. Your ideal home awaits—schedule a tour today!",
  "property_long_description": "Welcome to Wyndham Crossing, your ideal apartment community in the heart of Edmonton, AB. With an excellent selection of one, two, and three-bedroom floor plans, we provide spacious living options designed to meet your unique lifestyle needs. Our beautifully appointed apartments feature modern amenities for your convenience and comfort, including energy-efficient appliances, granite laminate countertops, and large closets to ensure you have plenty of storage space.\n\nAt Wyndham Crossing, we believe that home is where the heart is, which is why we have created a welcoming atmosphere for both you and your furry friends in our pet-friendly community. Enjoy leisurely strolls along our private walking trail, unwind at our indoor saltwater pool, or spend time in our cozy dining room. With complimentary on-site parking and convenient laundry facilities, you'll find all the essentials at your fingertips.\n\nFor peace of mind, our dedicated team offers 24-hour emergency maintenance, ensuring that your living experience is worry-free. Many of our select homes also include special features like USB outlets, renovated interiors, and captivating views*.\n\nTake advantage of our exclusive Shaw discount of 30-40%* and start enjoying the lifestyle you deserve today! Don’t wait—find your new home at Wyndham Crossing by browsing our availability or scheduling a tour of our vibrant community. Discover your next chapter in a place that truly feels like home.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-d3cd-708b-bbde-9acbc6e24456.webp",
  "property_featured_image_media": {
    "alt_text": "Indoor swimming pool with large windows overlooking the exterior.",
    "public_id": "019d0216-d3cd-708b-bbde-9acbc6e24456",
    "storage_key": "property/6767906449167131/019d0216-d3cd-708b-bbde-9acbc6e24456.webp",
    "width": 2560,
    "height": 936
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "50",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Cats and dogs are welcome (max 2 per unit), each up to 50 lbs. Non‑refundable pet fee: $300 for the first pet, $200 for the second. Monthly pet rent: $30 per pet. Breed restrictions apply; other small pets (e.g., hamsters, birds, reptiles, ferrets, turtles, fish) are allowed—tropical fish limited to a 20‑gallon tank. Service animals are permitted; reasonable accommodation requests considered case‑by‑case.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://wyndhamcrossing.securecafe.com/onlineleasing/wyndham-crossing/floorplans.aspx",
  "property_resident_portal_url": "https://wyndhamcrossing.securecafenet.com/residentservices/wyndham-crossing/userlogin",
  "property_apply_now_url": "https://wyndhamcrossing.securecafe.com/onlineleasing/wyndham-crossing/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-ddd2-74ae-a7b1-b2b6fd117ca4.webp",
  "property_primary_logo_media": {
    "alt_text": "Wyndham Crossing Apartment Homes logo.",
    "public_id": "019d0216-ddd2-74ae-a7b1-b2b6fd117ca4",
    "storage_key": "property/6767906449167131/019d0216-ddd2-74ae-a7b1-b2b6fd117ca4.webp",
    "width": 106,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-ea08-708a-9f88-e8111a4a442d.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Wyndham Crossing Apartment Homes logo",
    "public_id": "019d0216-ea08-708a-9f88-e8111a4a442d",
    "storage_key": "property/6767906449167131/019d0216-ea08-708a-9f88-e8111a4a442d.webp",
    "width": 106,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-f133-7114-b153-449d3d2d7fc4.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Wyndham Crossing Apartment Homes logo",
    "public_id": "019d0216-f133-7114-b153-449d3d2d7fc4",
    "storage_key": "property/6767906449167131/019d0216-f133-7114-b153-449d3d2d7fc4.webp",
    "width": 106,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#121212",
  "property_secondary_color": "#9d8b7e",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#4a7cbc",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": " - ",
  "property_sqft_min": "603",
  "property_sqft_max": null,
  "property_price_range": "875 - 1175",
  "property_price_min": "875",
  "property_price_max": "1175",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/WyndhamCrossingApartments",
  "property_instagram_url": "https://www.instagram.com/wyndhamedmontonhotel/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJfXNv0bg8oFMRdYpQF_zgFN8",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Wyndham Crossing",
  "property_home_romance_title": "Embrace a Life of Love in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Wyndham Crossing, where modern living meets tranquil nature in Edmonton, AB. Our spacious one, two, and three-bedroom apartments feature stunning views and generous amenities, including an indoor saltwater pool and a serene walking trail. Discover your ideal home today—your oasis awaits!",
  "property_home_floorplans_blurb": "Welcome to Wyndham Crossing in vibrant Edmonton, AB—where modern design meets comfort! Our diverse floor plans cater to every lifestyle, featuring open layouts and stylish finishes. Browse our available apartment homes today and uncover the perfect space that complements your unique way of living. Your ideal home awaits!",
  "property_home_gallery_blurb": "At Wyndham Crossing in Edmonton, AB, your ideal home awaits. Choose from spacious one to three-bedroom floor plans, complemented by a stunning indoor saltwater pool and serene walking trails. Enjoy modern amenities like granite countertops, energy-efficient appliances, and large closets. Picture yourself living here, surrounded by comfort and community!",
  "property_home_neighborhood_blurb": "Welcome to Wyndham Crossing, where spacious one, two, and three-bedroom apartments meet the vibrant heart of Edmonton. Embrace community life with nearby parks, libraries, and esteemed institutions like NorQuest College and MacEwan University. With attractions like Rogers Place and the Royal Alberta Museum around the corner, adventure awaits just outside your door!",
  "property_home_reviews_blurb": "At Wyndham Crossing in Edmonton, AB, residents rave about their vibrant community, highlighting, “The friendly atmosphere makes it feel like home.” Immerse yourself in a lifestyle filled with modern amenities and welcoming neighbors. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Wyndham Crossing in Edmonton, vibrant city life meets community comfort. Unwind at nearby lush parks like Borden Park and Rundle Park, or enjoy the cultural gem of the Royal Alberta Museum. With fantastic accessibility to NorQuest College and MacEwan University, every adventure is just moments away. See what's around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Wyndham Crossing in Edmonton, families find their haven among thoughtfully designed one, two, and three-bedroom apartments. Enjoy leisure at our indoor saltwater pool, stroll along the scenic walking trails, and unwind in spacious homes equipped with energy-efficient appliances. Your dream community awaits—come see what makes us unique!",
  "property_applynow_blurb": "Welcome to Wyndham Crossing in Edmonton, AB, where modern living meets comfort. Choose from spacious one, two, and three-bedroom floor plans, complete with energy-efficient amenities. Enjoy our indoor saltwater pool, serene walking trails, and pet-friendly environment. Lease online today and step into your new life filled with convenience and style!",
  "property_contactus_blurb": "At Wyndham Crossing in Edmonton, AB, you’ll find thoughtfully designed one, two, and three-bedroom floor plans tailored for your lifestyle. Each apartment offers a perfect blend of comfort and style. Got questions? Our friendly leasing team is here to assist—reach out today and start your journey home!",
  "property_faqs_blurb": "At Wyndham Crossing in Edmonton, AB, our diverse range of floor plans—one, two, or three bedrooms—caters to your unique lifestyle. Have questions? Visit our FAQs page for insights into our vibrant community and the amenities that make Wyndham Crossing your ideal home.",
  "property_floorplans_blurb": "At Wyndham Crossing in Edmonton, AB, our thoughtfully designed floor plans cater to every lifestyle. Choose from spacious one, two, or three-bedroom apartments that blend comfort and style. Each layout is crafted for modern living—browse our available homes today and discover the perfect fit for you!",
  "property_gallery_blurb": "At Wyndham Crossing in Edmonton, AB, imagine unwinding by our indoor saltwater pool or strolling along the lush private walking trail. Choose from spacious one, two, or three-bedroom layouts featuring modern amenities and exclusive Shaw discounts. Picture yourself living here—your tranquil oasis awaits! ",
  "property_interactivemap_blurb": "At Wyndham Crossing in Edmonton, AB, stylish living meets exceptional amenities. Choose from one, two, or three-bedroom apartments featuring energy-efficient appliances, large closets, and private balconies. Enjoy an indoor saltwater pool, serene walking trails, and 24-hour maintenance. Your perfect home awaits—unleash your lifestyle with our interactive community map today!",
  "property_pets_blurb": "At Wyndham Crossing in Edmonton, your furry friends are family! We welcome up to two pets per unit, ensuring they enjoy the space as much as you do. With ample room to explore and a community that understands their needs, life here is a joyful adventure for all.",
  "property_referafriend_blurb": "At Wyndham Crossing in Edmonton, AB, we offer a variety of floor plans, from cozy one-bedrooms to spacious three-bedrooms, ensuring the perfect match for every lifestyle. Great friends make great neighbors—refer a friend today and experience the joy of community living together!",
  "property_residentaccess_blurb": "At Wyndham Crossing in Edmonton, AB, choose from our thoughtfully designed one, two, and three-bedroom floor plans. Enjoy seamless living with our convenient resident portal—your gateway to paying rent, scheduling maintenance, and more. Access all you need to enhance your apartment experience today!",
  "property_reviews_blurb": "At Wyndham Crossing in Edmonton, residents relish the exceptional lifestyle our community offers. One resident enthusiastically shared, “The atmosphere feels like home, and the staff genuinely cares.” Check out our reviews to see firsthand how our vibrant community fosters connections and comfort—your ideal living experience awaits!",
  "property_created_at": "1771529095148",
  "property_scheduletour_blurb": "At Wyndham Crossing in Edmonton, AB, our diverse floor plans—ranging from cozy one-bedroom apartments to spacious three-bedroom homes—offer a perfect fit for every lifestyle. Schedule your tour today and see why our residents love calling this vibrant community home! Read their stories to learn more!",
  "property_thankyou_blurb": "Thank you for reaching out to Wyndham Crossing! Nestled in the heart of Edmonton, our thoughtfully designed one, two, and three-bedroom floor plans cater to every lifestyle.  Expect a member of our friendly team to connect with you soon to help you find your perfect home!",
  "property_virtualtours_blurb": "At Wyndham Crossing in Edmonton, AB, experience modern living with thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Each space offers comfort and elegance. Intrigued? Embark on a virtual tour of our vibrant community and apartments for rent today! Your new home awaits!",
  "property_copyright": "2026 All Rights Reserved. Wyndham Crossing",
  "property_seo_title_home": "Wyndham Crossing |  Apartments in Edmonton, AB",
  "property_seo_description_home": "Discover Wyndham Crossing in Edmonton! Enjoy spacious apartments, resort-style amenities, and a peaceful walking trail. Find your new home now!",
  "property_seo_title_floorplans": "Floor Plans | Edmonton, AB Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Wyndham Crossing in Edmonton, AB. Choose from stylish one, two, and three-bedroom floor plans that fit your lifestyle perfectly!",
  "property_seo_title_amenities": "Amenities | Edmonton, AB Apartments for Rent",
  "property_seo_description_amenities": "Experience the luxury of Wyndham Crossing in Edmonton, AB—featuring a saltwater pool, scenic trails, and pet-friendly homes. Your oasis awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Edmonton, AB",
  "property_seo_description_gallery": "Imagine life at Wyndham Crossing in Edmonton, AB, with spacious floor plans, resort-style amenities, and stunning views. Picture your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Wyndham Crossing Apartments",
  "property_seo_description_virtualtours": "Experience Wyndham Crossing in Edmonton, AB! Take a virtual tour of our stunning one, two, and three-bedroom apartments ready for you to call home.",
  "property_seo_title_interactivemap": "Interactive Map | Wyndham Crossing Apartments",
  "property_seo_description_interactivemap": "Discover Wyndham Crossing in Edmonton, AB! Enjoy spacious apartments, stunning views, great amenities, and a pet-friendly community. Find your home!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Edmonton, AB",
  "property_seo_description_neighborhood": "Explore the vibrant Wyndham Crossing neighborhood in Edmonton, AB, filled with local favorites and must-see hotspots right outside your door!",
  "property_seo_title_contact": "Contact Us | Wyndham Crossing",
  "property_seo_description_contact": "Connect with Wyndham Crossing in Edmonton! Inquire about our spacious one, two, and three-bedroom options. Your new home awaits—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Edmonton, AB",
  "property_seo_description_faqs": "Discover Wyndham Crossing in Edmonton, AB! Get your questions answered about our pet-friendly community with modern amenities and stunning views!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Edmonton, AB",
  "property_seo_description_reviews": "Discover Wyndham Crossing in Edmonton, AB! Explore resident reviews and see why our pet-friendly homes and cozy amenities stand out.",
  "property_seo_title_applynow": "Apply Now | Apartments in Edmonton, AB",
  "property_seo_description_applynow": "Elevate your lifestyle at Wyndham Crossing in Edmonton! Choose from spacious one to three-bedroom homes with luxury amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Wyndham Crossing",
  "property_seo_description_residentaccess": "Log in to Wyndham Crossing’s portal for easy rent payments, maintenance requests, and exclusive updates. Your comfy Edmonton life awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Wyndham Crossing",
  "property_seo_description_referafriend": "Refer a friend to Wyndham Crossing in Edmonton, AB! Great friends make great neighbors—share your love for our community and enjoy exclusive rewards together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Wyndham Crossing",
  "property_seo_description_scheduletour": "Experience luxury at Wyndham Crossing in Edmonton. Schedule your tour today and step into your future home where comfort meets style. Find your perfect fit!",
  "property_seo_title_privacy": "Privacy Policy | Wyndham Crossing",
  "property_seo_description_privacy": "At Wyndham Crossing in Edmonton, AB, your privacy matters. Read our privacy policy to learn how we protect your information and ensure your peace of mind.",
  "property_seo_title_accessibility": "Website Accessibility | Wyndham Crossing",
  "property_seo_description_accessibility": "At Wyndham Crossing, Edmonton, we champion digital inclusion and accessibility, creating a welcoming community for all.",
  "property_seo_title_sitemap": "Sitemap | Wyndham Crossing",
  "property_seo_description_sitemap": "Navigate your way through Wyndham Crossing! Check out our sitemap for easy access to all community features, amenities, and more in beautiful Edmonton, AB.",
  "property_seo_title_thankyou": "Thank You | Wyndham Crossing",
  "property_seo_description_thankyou": "Thank you for reaching out to Wyndham Crossing in Edmonton! Your info’s in safe hands—expect a warm welcome and swift response from our friendly team shortly.",
  "property_seo_title_pets": "Pet Policy | Apartments in Edmonton, AB",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293653259",
  "amenities": [
    {
      "id": "ec_f9f0753e6a956c2042f05100",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87492232",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e78f130c66467c0a6ea61678",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87492233",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-f3b0-74de-b1ad-9a3bde60c739.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of a large apartment building with multiple balconies and a grassy hill in front.",
        "public_id": "019d0214-f3b0-74de-b1ad-9a3bde60c739",
        "storage_key": "property/6767906449167131/019d0214-f3b0-74de-b1ad-9a3bde60c739.webp",
        "width": 2048,
        "height": 1367
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86e8c58a2b2e2e4b9a81fe2a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87492234",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cce92532752e8054e547123f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87492235",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_387bdb919e6c62cda475711e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87492237",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e0f9e5331b0eea005af5bde",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87492239",
      "title": "Pool [Under Renovation]",
      "amount": "false",
      "description": "Indoor and heated",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-f1eb-71fa-8c71-ac738e370eaf.webp",
      "amenity_image_media": {
        "alt_text": "Indoor swimming pool area with large windows overlooking the exterior.",
        "public_id": "019d0214-f1eb-71fa-8c71-ac738e370eaf",
        "storage_key": "property/6767906449167131/019d0214-f1eb-71fa-8c71-ac738e370eaf.webp",
        "width": 2048,
        "height": 1367
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1533183d1a013f448f78145",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87492240",
      "title": "Bilingual Leasing Team Members",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_779e4f13f23bf13511ef0ae1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87492238",
      "title": "Planned Social Activities/ Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94d79a939b835b301a00cb96",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87530501",
      "title": "Centrally Located",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a213db5f6855c13405d27dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "89458682",
      "title": "Walkability to Shopping and Restaurants",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5964d0785b9eed18f2609a0e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "89458684",
      "title": "Transit Bus Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7eb21844cbd78fa25fed600f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "89458687",
      "title": "Near River Valley",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8cc06ce410abc98c6bd8267",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "89458688",
      "title": "Near Clareview Rec Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ea91b1e7b1e98c075a333f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "89458698",
      "title": "Walkability to Canada Place",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9694d70141a27e01aeed20b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "89458701",
      "title": "Breathe Easy: Smoke-Free Community",
      "amount": "false",
      "description": "For more information visit www.weidner.com/breatheeasy.aspx",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bea5f2ea9d247c014e359783",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87492243",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d9a45-21b9-7061-8c06-7ae6671aea17.webp",
      "amenity_image_media": {
        "alt_text": "Empty closet with three shelves and wood floor",
        "public_id": "019d9a45-21b9-7061-8c06-7ae6671aea17",
        "storage_key": "property/6767906449167131/019d9a45-21b9-7061-8c06-7ae6671aea17.webp",
        "width": 1920,
        "height": 1281
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8c7df73a02f7a88df6608a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87492245",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-ef50-7147-b44b-f84baae8b34f.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with a view of trees and buildings",
        "public_id": "019d0214-ef50-7147-b44b-f84baae8b34f",
        "storage_key": "property/6767906449167131/019d0214-ef50-7147-b44b-f84baae8b34f.webp",
        "width": 2048,
        "height": 1367
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2e80d4a4267d2934e0efeef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87492246",
      "title": "Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3f3e150384b7d5a91fcc3716",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87492241",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-1fca-775d-8c73-986978770983.webp",
      "amenity_image_media": {
        "alt_text": "Empty apartment living room with neutral carpet and wall-to-wall carpeting.",
        "public_id": "019d0215-1fca-775d-8c73-986978770983",
        "storage_key": "property/6767906449167131/019d0215-1fca-775d-8c73-986978770983.webp",
        "width": 1024,
        "height": 684
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f68181849d6ffdfdfe6f05c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87492242",
      "title": "Intercom",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_539798dda7179ec3ff5d042a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "87492244",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e082fe8f20625d9508100ed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "89458690",
      "title": "Large Storage Rooms with Plug-ins",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6a6cda6f5e427cca102e252",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "89458691",
      "title": "Energy Efficient Appliances in Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1159cdef68d2b432ca4bae1c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "89458693",
      "title": "Fully Renovated Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c4d6b2475bab1384df2d4a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "120722595",
      "title": "Exclusive Shaw Discount of 30-40%*",
      "amount": "false",
      "description": "*Inquire with the leasing office for details.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_718c1c0ffcf94e3326549ead",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "123090383",
      "title": "USB Outlets*",
      "amount": "false",
      "description": "In renovated apartments only",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7738adf7f598a37ae0e1bfa5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "123090385",
      "title": "Granite Laminate Countertops*",
      "amount": "false",
      "description": "In renovated apartments only",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab8bd3022319ba1068c81dfe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "yardi",
      "external_id": "128350479",
      "title": "Additional 125 Square Feet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_e8a97b05c7a8c0fe4e23321c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-ca32-7728-9ddd-d0450f49932c.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, TV, and balcony view.",
        "public_id": "019d0214-ca32-7728-9ddd-d0450f49932c",
        "storage_key": "property/6767906449167131/019d0214-ca32-7728-9ddd-d0450f49932c.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in this spacious living room featuring a comfortable sectional sofa, a modern coffee table, and a large TV. Enjoy the natural light and balcony views.",
      "link": "false",
      "alt_text": "Living room with a sectional sofa, coffee table, TV, and balcony view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (1).jpg"
    },
    {
      "id": "ec_ceae46ecae617389f6baa70f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-c934-7631-b15e-f39030318045.webp",
      "image_media": {
        "alt_text": "Save up to $500 on select homes with Equal Housing Opportunity logo.",
        "public_id": "019d0214-c934-7631-b15e-f39030318045",
        "storage_key": "property/6767906449167131/019d0214-c934-7631-b15e-f39030318045.webp",
        "width": 1084,
        "height": 684
      },
      "title": "Other",
      "description": "Special offer: Save up to $500 on select homes. Contact the leasing office for details on this limited-time offer. Equal Housing Opportunity.",
      "link": "false",
      "alt_text": "Save up to $500 on select homes with Equal Housing Opportunity logo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Specials (2378).png"
    },
    {
      "id": "ec_8df636b117b633903ffbf59a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-cc24-74be-b37f-a396d2e1652e.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, granite countertops, and black appliances.",
        "public_id": "019d0214-cc24-74be-b37f-a396d2e1652e",
        "storage_key": "property/6767906449167131/019d0214-cc24-74be-b37f-a396d2e1652e.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring light wood cabinetry, speckled granite countertops, a double sink, and black appliances including a refrigerator and stove. The flooring is a light wood laminate.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, granite countertops, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (2).jpg"
    },
    {
      "id": "ec_0b91bf76a64d2d667a30717a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-ca30-7264-9202-770099664b47.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, wood cabinets, double sink, and white stove.",
        "public_id": "019d0214-ca30-7264-9202-770099664b47",
        "storage_key": "property/6767906449167131/019d0214-ca30-7264-9202-770099664b47.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample wood cabinetry, a double sink, and a white gas range, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with white refrigerator, wood cabinets, double sink, and white stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (3).jpg"
    },
    {
      "id": "ec_365ad11ead3820c26c20e96a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-d2dd-778c-9aff-5623acfd1627.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, nightstand, and window.",
        "public_id": "019d0214-d2dd-778c-9aff-5623acfd1627",
        "storage_key": "property/6767906449167131/019d0214-d2dd-778c-9aff-5623acfd1627.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a comfortable queen-sized bed, a modern nightstand with a lamp, and a large window with a view of the outdoors.",
      "link": "false",
      "alt_text": "Bedroom with a queen-sized bed, nightstand, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (4).jpg"
    },
    {
      "id": "ec_d6b859cb53bc4e1ed8739f4f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-d79c-7597-9dac-d990b5a79dbf.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, mirror, toilet, and bathtub.",
        "public_id": "019d0214-d79c-7597-9dac-d990b5a79dbf",
        "storage_key": "property/6767906449167131/019d0214-d79c-7597-9dac-d990b5a79dbf.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a sink, a large mirror, a toilet, and a bathtub with light pink tiled walls.",
      "link": "false",
      "alt_text": "Bathroom with vanity, mirror, toilet, and bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (5).jpg"
    },
    {
      "id": "ec_a9b6e352cfd8d32ff87d2f8b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-d869-713c-9ee5-5cca6f659ac1.webp",
      "image_media": {
        "alt_text": "Spacious living room with large window and access to balcony.",
        "public_id": "019d0214-d869-713c-9ee5-5cca6f659ac1",
        "storage_key": "property/6767906449167131/019d0214-d869-713c-9ee5-5cca6f659ac1.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this expansive living room, featuring a large window that floods the space with natural light and offers access to a private balcony.",
      "link": "false",
      "alt_text": "Spacious living room with large window and access to balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (6).jpg"
    },
    {
      "id": "ec_bfaca7af39f93c4b58024cb0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-d8e1-767f-ba57-dbb5b495d1f4.webp",
      "image_media": {
        "alt_text": "Spacious living room with large window and sliding glass door.",
        "public_id": "019d0214-d8e1-767f-ba57-dbb5b495d1f4",
        "storage_key": "property/6767906449167131/019d0214-d8e1-767f-ba57-dbb5b495d1f4.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Bright and airy living room with modern flooring and ample natural light from a large window. Perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Spacious living room with large window and sliding glass door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (7).jpg"
    },
    {
      "id": "ec_9ad0de18cc704fda24cd5a0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-ca30-7264-9202-770099664b47.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, wood cabinets, double sink, and white stove.",
        "public_id": "019d0214-ca30-7264-9202-770099664b47",
        "storage_key": "property/6767906449167131/019d0214-ca30-7264-9202-770099664b47.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample wood cabinetry, a double sink, and a white gas range, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with white refrigerator, wood cabinets, double sink, and white stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (8).jpg"
    },
    {
      "id": "ec_9b685ddf66085b12127c5b32",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-dfa9-73ce-b6d8-1d07de551948.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, black stove, and stainless steel sink.",
        "public_id": "019d0214-dfa9-73ce-b6d8-1d07de551948",
        "storage_key": "property/6767906449167131/019d0214-dfa9-73ce-b6d8-1d07de551948.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring light wood cabinetry, granite countertops, a black electric stove, and a double stainless steel sink.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, black stove, and stainless steel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (9).jpg"
    },
    {
      "id": "ec_fd46487c2346e77c74ad195a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-e2ca-708b-992c-8167f8b96abb.webp",
      "image_media": {
        "alt_text": "Empty bedroom with closet and view into a bathroom.",
        "public_id": "019d0214-e2ca-708b-992c-8167f8b96abb",
        "storage_key": "property/6767906449167131/019d0214-e2ca-708b-992c-8167f8b96abb.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a large closet and an adjacent bathroom, perfect for comfortable living.",
      "link": "false",
      "alt_text": "Empty bedroom with closet and view into a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (10).jpg"
    },
    {
      "id": "ec_dcd7a32a1d5432e6fc38e053",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-e55c-772d-8012-47db067a9c30.webp",
      "image_media": {
        "alt_text": "Bedroom with carpet and sliding closet doors",
        "public_id": "019d0214-e55c-772d-8012-47db067a9c30",
        "storage_key": "property/6767906449167131/019d0214-e55c-772d-8012-47db067a9c30.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting and a large sliding closet, offering ample storage space.",
      "link": "false",
      "alt_text": "Bedroom with carpet and sliding closet doors",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (11).jpg"
    },
    {
      "id": "ec_f31d0f953b9cf90429ed4816",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-e760-7068-9dac-ac52ac077360.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with sink and mirror.",
        "public_id": "019d0214-e760-7068-9dac-ac52ac077360",
        "storage_key": "property/6767906449167131/019d0214-e760-7068-9dac-ac52ac077360.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a clean white bathtub, toilet, and a vanity with a granite countertop and ample storage.",
      "link": "false",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity with sink and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (12).jpg"
    },
    {
      "id": "ec_6f8c651b21e79ced2d2d6774",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-eba5-75d9-97e1-43495c91e1ba.webp",
      "image_media": {
        "alt_text": "A modern bathroom with a white bathtub, toilet, and granite countertop.",
        "public_id": "019d0214-eba5-75d9-97e1-43495c91e1ba",
        "storage_key": "property/6767906449167131/019d0214-eba5-75d9-97e1-43495c91e1ba.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Enjoy a refreshing soak in the bathtub or freshen up at the spacious vanity in this well-appointed bathroom.",
      "link": "false",
      "alt_text": "A modern bathroom with a white bathtub, toilet, and granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (13).jpg"
    },
    {
      "id": "ec_2e36db6ec567d80e6961ec8e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-ef50-7147-b44b-f84baae8b34f.webp",
      "image_media": {
        "alt_text": "Balcony with a view of trees and buildings",
        "public_id": "019d0214-ef50-7147-b44b-f84baae8b34f",
        "storage_key": "property/6767906449167131/019d0214-ef50-7147-b44b-f84baae8b34f.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Enjoy the outdoors on your private balcony, offering a peaceful view of the surrounding greenery and cityscape.",
      "link": "false",
      "alt_text": "Balcony with a view of trees and buildings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (14).jpg"
    },
    {
      "id": "ec_bfe6d21c60283fd890d5840c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-f1eb-71fa-8c71-ac738e370eaf.webp",
      "image_media": {
        "alt_text": "Indoor swimming pool area with large windows overlooking the exterior.",
        "public_id": "019d0214-f1eb-71fa-8c71-ac738e370eaf",
        "storage_key": "property/6767906449167131/019d0214-f1eb-71fa-8c71-ac738e370eaf.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our indoor pool, perfect for year-round relaxation and exercise.",
      "link": "false",
      "alt_text": "Indoor swimming pool area with large windows overlooking the exterior.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (15).jpg"
    },
    {
      "id": "ec_a61a52a3186f31346b67c757",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-f3b0-74de-b1ad-9a3bde60c739.webp",
      "image_media": {
        "alt_text": "Exterior view of a large apartment building with multiple balconies and a grassy hill in front.",
        "public_id": "019d0214-f3b0-74de-b1ad-9a3bde60c739",
        "storage_key": "property/6767906449167131/019d0214-f3b0-74de-b1ad-9a3bde60c739.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Spacious apartment building exterior with balconies and lush green grounds. Enjoy comfortable living in this community.",
      "link": "false",
      "alt_text": "Exterior view of a large apartment building with multiple balconies and a grassy hill in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (16).jpg"
    },
    {
      "id": "ec_201c52b350fd7f1fb73a3a13",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0214-f60f-7179-aa35-730c067889fe.webp",
      "image_media": {
        "alt_text": "Wyndham Crossing Apartment Homes sign with flowers in the foreground.",
        "public_id": "019d0214-f60f-7179-aa35-730c067889fe",
        "storage_key": "property/6767906449167131/019d0214-f60f-7179-aa35-730c067889fe.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Wyndham Crossing Apartment Homes, a community offering comfortable living with a touch of nature.",
      "link": "false",
      "alt_text": "Wyndham Crossing Apartment Homes sign with flowers in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CAN_Wyndham-Crossing_Favorites (17).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_db0e97c7-6b26-4dfd-8b11-01be86d2d11a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Yang Ming Buffet",
      "poi_type": "Restaurants",
      "poi_address": "3414 118 Ave NW, Edmonton, AB T5W 1G7, Canada",
      "poi_short_description": "Large, contemporary buffet providing an array of Chinese dishes & sushi rolls, plus a full bar.",
      "poi_long_description": "Large, contemporary buffet providing an array of Chinese dishes & sushi rolls, plus a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-1431-72cc-899c-140232f0e794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-1431-72cc-899c-140232f0e794",
        "storage_key": "property/6767906449167131/019d0216-1431-72cc-899c-140232f0e794.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://yangmingbuffet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18128039888186407242&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yang-ming-buffet",
      "poi_latitude": "53.5712753",
      "poi_longitude": "-113.3945778",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 780-752-7888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d311-726e-a983-8b535f17f3ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d311-726e-a983-8b535f17f3ca",
        "storage_key": "property/6767906449167131/019d0215-d311-726e-a983-8b535f17f3ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ01QfOyY9oFMRSnl2WTu8k_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_c3e14ae9-7dca-4ace-ae5c-8064afa59e69",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Cactus Club Cafe",
      "poi_type": "Restaurants",
      "poi_address": "11130 Jasper Ave, Edmonton, AB T5K 0C7, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-1429-733f-8e8e-7f72c08deedf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-1429-733f-8e8e-7f72c08deedf",
        "storage_key": "property/6767906449167131/019d0216-1429-733f-8e8e-7f72c08deedf.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.cactusclubcafe.com/locations/jasper-avenue/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6750731771304495348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cactus-club-cafe",
      "poi_latitude": "53.5411626",
      "poi_longitude": "-113.5132776",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 587-523-8030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d311-726e-a983-8b535f17f3ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d311-726e-a983-8b535f17f3ca",
        "storage_key": "property/6767906449167131/019d0215-d311-726e-a983-8b535f17f3ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR0AIwzAioFMR9EiMcsdqr10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7dc6deb9-cada-410c-be66-62e5077bb343",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Tiramisu Bistro",
      "poi_type": "Restaurants",
      "poi_address": "10750 124 St, Edmonton, AB T5M 0H1, Canada",
      "poi_short_description": "Casual, colorful Italian spot for pizza, panini & pasta, plus breakfast & coffee.",
      "poi_long_description": "Casual, colorful Italian spot for pizza, panini & pasta, plus breakfast & coffee.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-1470-7361-9e9a-6b2d4195efbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-1470-7361-9e9a-6b2d4195efbd",
        "storage_key": "property/6767906449167131/019d0216-1470-7361-9e9a-6b2d4195efbd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://tiramisubistro.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=317362290734531294&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tiramisu-bistro",
      "poi_latitude": "53.5523908",
      "poi_longitude": "-113.5362982",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 780-452-3393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d311-726e-a983-8b535f17f3ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d311-726e-a983-8b535f17f3ca",
        "storage_key": "property/6767906449167131/019d0215-d311-726e-a983-8b535f17f3ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9-XX7UqjY0ER3gJWbFJ_ZwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_b5c939c5-5ce2-4d96-a07e-dd262eb79ac7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Dave's Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "10832 102 Ave NW, Edmonton, AB T5J 0G3, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-146f-7627-8ef8-6c06bd8c80ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-146f-7627-8ef8-6c06bd8c80ba",
        "storage_key": "property/6767906449167131/019d0216-146f-7627-8ef8-6c06bd8c80ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://restaurants.daveshotchicken.com/canada/ab/edmonton-ab-102-ave-nw/?utm_campaign=google_maps&utm_medium=organic&utm_source=google&utm_content=website&utm_keyword=1328",
      "poi_directions_map_url": "https://maps.google.com/?cid=15223502077985729697&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "daves-hot-chicken",
      "poi_latitude": "53.54320209999999",
      "poi_longitude": "-113.5080296",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 780-249-1263",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d311-726e-a983-8b535f17f3ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d311-726e-a983-8b535f17f3ca",
        "storage_key": "property/6767906449167131/019d0215-d311-726e-a983-8b535f17f3ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr9bJBAAjoFMRoazCe3u-RNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_9034c9cf-7822-4aaa-bdc7-8ab3fa98141a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Campio Brewing Co.",
      "poi_type": "Restaurants",
      "poi_address": "10257 105 St NW, Edmonton, AB T5J 1E3, Canada",
      "poi_short_description": "Casual, wood-lined brewery serving craft beers, cocktails & hearty comfort food, plus weekly brunch.",
      "poi_long_description": "Casual, wood-lined brewery serving craft beers, cocktails & hearty comfort food, plus weekly brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-1d4d-77ea-bfe1-415d847e5330.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-1d4d-77ea-bfe1-415d847e5330",
        "storage_key": "property/6767906449167131/019d0216-1d4d-77ea-bfe1-415d847e5330.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.campiobrewingco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1462759303189088236&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "campio-brewing-co",
      "poi_latitude": "53.5442303",
      "poi_longitude": "-113.5008297",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 587-635-1952",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d311-726e-a983-8b535f17f3ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d311-726e-a983-8b535f17f3ca",
        "storage_key": "property/6767906449167131/019d0215-d311-726e-a983-8b535f17f3ca.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIYeaiLQjoFMR7Md7EtbDTBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_664326db-36b2-4a2c-96b0-e3831f7721f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Kingsway Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "109 Kingsway NW, Edmonton, AB T5G 3A6, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-1cfc-77f6-b142-82aa92ca577f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-1cfc-77f6-b142-82aa92ca577f",
        "storage_key": "property/6767906449167131/019d0216-1cfc-77f6-b142-82aa92ca577f.webp",
        "width": 1280,
        "height": 926
      },
      "poi_business_url": "http://www.kingswaymall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2320795468540300301&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kingsway-mall",
      "poi_latitude": "53.5628833",
      "poi_longitude": "-113.5061502",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 780-477-5756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d1f6-7358-bdc5-0f50d1ee5866.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d1f6-7358-bdc5-0f50d1ee5866",
        "storage_key": "property/6767906449167131/019d0215-d1f6-7358-bdc5-0f50d1ee5866.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJD67obrAjoFMRDUyuui4fNSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b3593863-8ca7-49a5-9ded-77b42639389f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Londonderry Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "1 Londonderry Mall NW, Edmonton, AB T5C 3C8, Canada",
      "poi_short_description": "Airy, everyday mall with 100+ stores, fast-food restaurants & consumer services on 2 floors.",
      "poi_long_description": "Airy, everyday mall with 100+ stores, fast-food restaurants & consumer services on 2 floors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-c8b0-7020-8a5c-c57c57bc396f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-c8b0-7020-8a5c-c57c57bc396f",
        "storage_key": "property/6767906449167131/019d0215-c8b0-7020-8a5c-c57c57bc396f.webp",
        "width": 1280,
        "height": 876
      },
      "poi_business_url": "http://www.londonderrymall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=272641402258078120&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "londonderry-mall",
      "poi_latitude": "53.6023975",
      "poi_longitude": "-113.4459579",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 780-476-1441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d1f6-7358-bdc5-0f50d1ee5866.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d1f6-7358-bdc5-0f50d1ee5866",
        "storage_key": "property/6767906449167131/019d0215-d1f6-7358-bdc5-0f50d1ee5866.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHx6MZEgjoFMRqDmoLOmdyAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_0351596f-1840-4111-9417-b3f8bb2016c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Real Canadian Superstore Kingsway Avenue",
      "poi_type": "Shopping & Retail",
      "poi_address": "11541 Kingsway NW, Edmonton, AB T5G 3E8, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-1cee-74a7-9c4f-374c6f2afcd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-1cee-74a7-9c4f-374c6f2afcd3",
        "storage_key": "property/6767906449167131/019d0216-1cee-74a7-9c4f-374c6f2afcd3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.realcanadiansuperstore.ca/store-locator/details/1502?utm_source=G&utm_medium=LPM&utm_campaign=Loblaws",
      "poi_directions_map_url": "https://maps.google.com/?cid=9887551508809739814&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "real-canadian-superstore-kingsway-avenue",
      "poi_latitude": "53.564846",
      "poi_longitude": "-113.521537",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 780-733-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d57a-719c-ab94-88addd5d47e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d57a-719c-ab94-88addd5d47e3",
        "storage_key": "property/6767906449167131/019d0215-d57a-719c-ab94-88addd5d47e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpRRkwbgjoFMRJm779LWjN4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_39f1dd94-2d94-4cf4-9267-8944a6e9f316",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "T&T Supermarket Northtown Edmonton Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "9450 137 Ave NW #158, Edmonton, AB T5E 6C2, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-1e6f-751b-b1a0-bbbafb0b70e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-1e6f-751b-b1a0-bbbafb0b70e1",
        "storage_key": "property/6767906449167131/019d0216-1e6f-751b-b1a0-bbbafb0b70e1.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.tntsupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7563841533381138751&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tt-supermarket-northtown-edmonton-store",
      "poi_latitude": "53.60084149999999",
      "poi_longitude": "-113.4877319",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 780-409-8686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d57a-719c-ab94-88addd5d47e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d57a-719c-ab94-88addd5d47e3",
        "storage_key": "property/6767906449167131/019d0215-d57a-719c-ab94-88addd5d47e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSbgh6WEjoFMRP1mHtswp-Gg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_7e109187-80ec-469d-bf7a-6a7854b0083f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Lucky Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10725 97 St NW, Edmonton, AB T5H 2L9, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-227c-740c-abf6-fc4ca266bea8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-227c-740c-abf6-fc4ca266bea8",
        "storage_key": "property/6767906449167131/019d0216-227c-740c-abf6-fc4ca266bea8.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "http://www.luckysupermarket.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11330113124109896334&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lucky-supermarket",
      "poi_latitude": "53.5523433",
      "poi_longitude": "-113.4891079",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 780-424-8011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d57a-719c-ab94-88addd5d47e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d57a-719c-ab94-88addd5d47e3",
        "storage_key": "property/6767906449167131/019d0215-d57a-719c-ab94-88addd5d47e3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9e-ZV1IioFMRjsqPW9ulPJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_e2be4c06-060d-4d28-a2bf-29f18e3e54cc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "NorQuest College",
      "poi_type": "Education",
      "poi_address": "10215 108 St NW, Edmonton, AB T5J 1L6, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-8887-77ed-bb01-09f49ce0fa8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-8887-77ed-bb01-09f49ce0fa8c",
        "storage_key": "property/6767906449167131/019d0215-8887-77ed-bb01-09f49ce0fa8c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.norquest.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1639172302993384322&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norquest-college",
      "poi_latitude": "53.543879",
      "poi_longitude": "-113.5062411",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 866-534-7218",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d584-715e-a4c8-db748f497663.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d584-715e-a4c8-db748f497663",
        "storage_key": "property/6767906449167131/019d0215-d584-715e-a4c8-db748f497663.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU9OUSjYioFMRgmOUXYaCvxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_524eb6ae-5584-439e-a388-c6b75c6e8388",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "MacEwan University",
      "poi_type": "Education",
      "poi_address": "10700 104 Ave NW, Edmonton, AB T5H 2Z8, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-24bd-7162-b0d5-eb6f33edd8d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-24bd-7162-b0d5-eb6f33edd8d4",
        "storage_key": "property/6767906449167131/019d0216-24bd-7162-b0d5-eb6f33edd8d4.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "https://www.macewan.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10847773759030836400&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "macewan-university",
      "poi_latitude": "53.5467424",
      "poi_longitude": "-113.5063018",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 780-497-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d584-715e-a4c8-db748f497663.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d584-715e-a4c8-db748f497663",
        "storage_key": "property/6767906449167131/019d0215-d584-715e-a4c8-db748f497663.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXRO4lDoZoFMRsDzWhsIIi5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b6ba331e-9c80-417f-b517-64c821384d8c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Feltham Centre (CAT)",
      "poi_type": "Education",
      "poi_address": "11763 106 St, Edmonton, AB T5G 2R1, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-24c5-773f-871e-3a397ccfcc48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-24c5-773f-871e-3a397ccfcc48",
        "storage_key": "property/6767906449167131/019d0216-24c5-773f-871e-3a397ccfcc48.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.nait.ca/nait/about/our-campuses/centre-for-applied-technology",
      "poi_directions_map_url": "https://maps.google.com/?cid=711780858906195732&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "feltham-centre-cat",
      "poi_latitude": "53.5700284",
      "poi_longitude": "-113.502206",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 780-471-6248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d584-715e-a4c8-db748f497663.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d584-715e-a4c8-db748f497663",
        "storage_key": "property/6767906449167131/019d0215-d584-715e-a4c8-db748f497663.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe6M5DaQjoFMRFLcGhevA4Ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_05f9e429-d746-47a7-ac70-aebedfc5904e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Concordia University of Edmonton",
      "poi_type": "Education",
      "poi_address": "7128 Ada Blvd NW, Edmonton, AB T5B 4E3, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-859f-74ee-8387-aa2f4ccba62b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-859f-74ee-8387-aa2f4ccba62b",
        "storage_key": "property/6767906449167131/019d0215-859f-74ee-8387-aa2f4ccba62b.webp",
        "width": 820,
        "height": 287
      },
      "poi_business_url": "https://concordia.ab.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16757752370704540033&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "concordia-university-of-edmonton",
      "poi_latitude": "53.5600409",
      "poi_longitude": "-113.4456839",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 780-479-8481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d584-715e-a4c8-db748f497663.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d584-715e-a4c8-db748f497663",
        "storage_key": "property/6767906449167131/019d0215-d584-715e-a4c8-db748f497663.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ97DAkeAioFMRgeHNqf5-j-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d01d3074-ccea-447a-bd42-a300e3d46d7b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Edmonton Public Library - Stanley A. Milner (Downtown)",
      "poi_type": "Education",
      "poi_address": "7 Sir Winston Churchill Sq NW, Edmonton, AB T5J 2V5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-2b20-7665-b774-f3c54aab45d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-2b20-7665-b774-f3c54aab45d3",
        "storage_key": "property/6767906449167131/019d0216-2b20-7665-b774-f3c54aab45d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.epl.ca/locations/EPLMNA/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14308076070418717452&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edmonton-public-library---stanley-a-milner-downtown",
      "poi_latitude": "53.5430825",
      "poi_longitude": "-113.4897956",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 780-496-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d584-715e-a4c8-db748f497663.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d584-715e-a4c8-db748f497663",
        "storage_key": "property/6767906449167131/019d0215-d584-715e-a4c8-db748f497663.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzzMgnUUioFMRDBuT7GB_kMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_72162863-2a28-4ebc-bb66-7ccf8e22db3b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Rogers Place",
      "poi_type": "Entertainment",
      "poi_address": "10220 104 Ave NW, Edmonton, AB T5J 0H6, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-9660-734e-aeb3-1a0d024434d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-9660-734e-aeb3-1a0d024434d8",
        "storage_key": "property/6767906449167131/019d0215-9660-734e-aeb3-1a0d024434d8.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.rogersplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4606154258069902552&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rogers-place",
      "poi_latitude": "53.54697549999999",
      "poi_longitude": "-113.4978004",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 780-414-5483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFSwFuE4ioFMR2NTorORY7D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_dc77fd84-5df4-4874-bc4f-d5e74b4b49c5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Commonwealth Stadium",
      "poi_type": "Entertainment",
      "poi_address": "11000 Stadium Rd NW, Edmonton, AB T5J 2R7, Canada",
      "poi_short_description": "60,000-seat home of the Edmonton Eskimos also hosting soccer & other sporting events, plus concerts.",
      "poi_long_description": "60,000-seat home of the Edmonton Eskimos also hosting soccer & other sporting events, plus concerts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-2bf6-73d2-9b56-469989411da2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-2bf6-73d2-9b56-469989411da2",
        "storage_key": "property/6767906449167131/019d0216-2bf6-73d2-9b56-469989411da2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.edmonton.ca/attractions_events/commonwealth-stadium",
      "poi_directions_map_url": "https://maps.google.com/?cid=14759348457789422083&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "commonwealth-stadium",
      "poi_latitude": "53.5597151",
      "poi_longitude": "-113.4761643",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 780-442-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-5733-70bf-a2e6-83d29a88fc3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-5733-70bf-a2e6-83d29a88fc3e",
        "storage_key": "property/6767906449167131/019d0216-5733-70bf-a2e6-83d29a88fc3e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZRvp1wEjoFMRA3q_Vjm908w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_e8f8a9d8-fa72-4642-97bf-c3d217bae415",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Royal Alberta Museum",
      "poi_type": "Entertainment",
      "poi_address": "9810 103a Ave NW, Edmonton, AB T5J 0G2, Canada",
      "poi_short_description": "Exhibits on Alberta's geological & human history, including First Peoples, plus fossils & wildlife.",
      "poi_long_description": "Exhibits on Alberta's geological & human history, including First Peoples, plus fossils & wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-935f-7436-899c-b575f2140a1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-935f-7436-899c-b575f2140a1f",
        "storage_key": "property/6767906449167131/019d0215-935f-7436-899c-b575f2140a1f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://royalalbertamuseum.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17558588412308519627&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "royal-alberta-museum",
      "poi_latitude": "53.5467631",
      "poi_longitude": "-113.4892097",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 825-468-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d944-77ed-ad57-ebb98e708d27.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d944-77ed-ad57-ebb98e708d27",
        "storage_key": "property/6767906449167131/019d0215-d944-77ed-ad57-ebb98e708d27.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJK92YK1AioFMRy3rwsCGjrPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_10d25de1-0378-452f-b7a2-775b85071185",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Castle Downs Arena",
      "poi_type": "Entertainment",
      "poi_address": "11520 153 Ave NW, Edmonton, AB T5X 5S5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-2c35-736e-a6d5-21141f87fe7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-2c35-736e-a6d5-21141f87fe7c",
        "storage_key": "property/6767906449167131/019d0216-2c35-736e-a6d5-21141f87fe7c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.edmonton.ca/activities_parks_recreation/arenas",
      "poi_directions_map_url": "https://maps.google.com/?cid=2695359477951249239&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "castle-downs-arena",
      "poi_latitude": "53.615731",
      "poi_longitude": "-113.5204836",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 780-442-4546",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd-fglIwkoFMRVztEISrXZyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_9ec98a9b-d75e-4de2-8802-b243b1720479",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Alberta Aviation Museum",
      "poi_type": "Entertainment",
      "poi_address": "11410 Kingsway NW, Edmonton, AB T5G 0X3, Canada",
      "poi_short_description": "Old airfield hangar with displays on local flight history & pioneers plus over 40 vintage airplanes.",
      "poi_long_description": "Old airfield hangar with displays on local flight history & pioneers plus over 40 vintage airplanes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-2ddc-7093-ae40-bbc303a0bd51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-2ddc-7093-ae40-bbc303a0bd51",
        "storage_key": "property/6767906449167131/019d0216-2ddc-7093-ae40-bbc303a0bd51.webp",
        "width": 1280,
        "height": 383
      },
      "poi_business_url": "http://www.albertaaviationmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2088443591904779950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alberta-aviation-museum",
      "poi_latitude": "53.5653803",
      "poi_longitude": "-113.5168355",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 780-451-1175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d944-77ed-ad57-ebb98e708d27.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d944-77ed-ad57-ebb98e708d27",
        "storage_key": "property/6767906449167131/019d0215-d944-77ed-ad57-ebb98e708d27.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJnRp-DrkjoFMRrt7svGGk-xw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_890eb1a0-69c6-4218-84a4-45f6c5a22303",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "MOVATI Athletic Manning",
      "poi_type": "Health and Wellness",
      "poi_address": "15812 34 St NW, Edmonton, AB T5Y 0S5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-32df-76e1-94f0-8db4d825eecb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-32df-76e1-94f0-8db4d825eecb",
        "storage_key": "property/6767906449167131/019d0216-32df-76e1-94f0-8db4d825eecb.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://movatiathletic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11629969104630466760&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "movati-athletic-manning",
      "poi_latitude": "53.620209",
      "poi_longitude": "-113.394082",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 780-652-1036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm4NBRak9oFMRyEhETkjzZaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_ee1828df-5e07-4ca0-b854-38c2c8d8de71",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "GoodLife Fitness Edmonton Brewery District",
      "poi_type": "Health and Wellness",
      "poi_address": "11962 104 Ave NW #201, Edmonton, AB T5K 2T7, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-32c6-775f-b001-43d730a03004.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-32c6-775f-b001-43d730a03004",
        "storage_key": "property/6767906449167131/019d0216-32c6-775f-b001-43d730a03004.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.goodlifefitness.com/clubs/club.287.html?utm_source=G&utm_medium=LPM&utm_campaign=GoodlifeFitness",
      "poi_directions_map_url": "https://maps.google.com/?cid=46274191637681937&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "goodlife-fitness-edmonton-brewery-district",
      "poi_latitude": "53.547573",
      "poi_longitude": "-113.527009",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 780-428-7004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ69TyqjIioFMRERfV0iFmpAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f569bee9-fabc-41a9-a9ae-f08263c6290f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "MOVATI Athletic Albany",
      "poi_type": "Health and Wellness",
      "poi_address": "135 Albany Dr NW, Edmonton, AB T6V 1J6, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-3511-72e8-ad3f-935f41a00e54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-3511-72e8-ad3f-935f41a00e54",
        "storage_key": "property/6767906449167131/019d0216-3511-72e8-ad3f-935f41a00e54.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://movatiathletic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5751973726212798989&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "movati-athletic-albany",
      "poi_latitude": "53.6308739",
      "poi_longitude": "-113.5464817",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 780-652-1037",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ydZb78loFMRDTpL9KAd008",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_84dc18b9-aad8-4ab1-a442-1e5bd143a59d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Don Wheaton Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "10211 102 Ave NW, Edmonton, AB T5J 0A5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-34d2-7155-9531-26066d1f1618.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-34d2-7155-9531-26066d1f1618",
        "storage_key": "property/6767906449167131/019d0216-34d2-7155-9531-26066d1f1618.webp",
        "width": 1280,
        "height": 704
      },
      "poi_business_url": "https://ymcanab.ca/locations/don-wheaton-family-ymca?utm_medium=organic&utm_source=google&utm_campaign=gbp-dw",
      "poi_directions_map_url": "https://maps.google.com/?cid=6106108390586005216&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "don-wheaton-family-ymca",
      "poi_latitude": "53.5428873",
      "poi_longitude": "-113.4969979",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 780-452-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ316QmEgioFMR4DbpzDpBvVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_43412e73-72ae-47a1-be9b-9ed4ff5d34fd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "White Oaks Square, 12222 137 Ave NW, Edmonton, AB T5L 4X5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-39d5-77e9-832f-da4386de24f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-39d5-77e9-832f-da4386de24f3",
        "storage_key": "property/6767906449167131/019d0216-39d5-77e9-832f-da4386de24f3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.ca/gyms/edmonton-white-oaks-ab?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1961999273206303831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "53.60083",
      "poi_longitude": "-113.53275",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 780-809-7859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4aD0jvsloFMRV0wJofFrOhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0748ca3c-141a-46f4-9abd-5533bc40b50f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "GoodLife Fitness Edmonton Clareview Town Centre",
      "poi_type": "Health and Wellness",
      "poi_address": "4211 139 Ave NW, Edmonton, AB T5Y 2W8, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.goodlifefitness.com/clubs/club.193.html?utm_source=G&utm_medium=LPM&utm_campaign=GoodlifeFitness",
      "poi_directions_map_url": "https://maps.google.com/?cid=17191420134085034223&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "goodlife-fitness-edmonton-clareview-town-centre",
      "poi_latitude": "53.59981999999999",
      "poi_longitude": "-113.407875",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 587-459-9360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJveflZ748oFMR7wCjJIcxlO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_86cb85ed-f0d7-4ede-a0ec-91f74b4fb3b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Fit4Less",
      "poi_type": "Health and Wellness",
      "poi_address": "6606 137 Ave NW #1102, Edmonton, AB T5C 2L2, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.fit4less.ca/locations/provinces/alberta/edmonton/edmonton-londonderry-mall?utm_source=G&utm_medium=lpm&utm_campaign=fit4less",
      "poi_directions_map_url": "https://maps.google.com/?cid=17870345679708993150&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fit4less",
      "poi_latitude": "53.602011",
      "poi_longitude": "-113.448088",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 780-472-7995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQYnjolIjoFMRfrZ97LY4APg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9af248c7-4cda-4b08-921c-0db6a506a480",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "O'Leary Fitness And Leisure Centre",
      "poi_type": "Health and Wellness",
      "poi_address": "8804 132 Ave NW, Edmonton, AB T5E 0X9, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.edmonton.ca/activities_parks_recreation/oleary",
      "poi_directions_map_url": "https://maps.google.com/?cid=2986767979322430299&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oleary-fitness-and-leisure-centre",
      "poi_latitude": "53.5928567",
      "poi_longitude": "-113.4766033",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 780-442-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-aDzeWgjoFMRW1MGEqchcyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6144586f-dfb9-4ee5-a1eb-96fb88890b33",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Royal Alexandra Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "10240 Kingsway NW, Edmonton, AB T5H 3V9, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.albertahealthservices.ca/findhealth/facility.aspx?id=6598",
      "poi_directions_map_url": "https://maps.google.com/?cid=6996685127410725108&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "royal-alexandra-hospital",
      "poi_latitude": "53.5573875",
      "poi_longitude": "-113.4977721",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 780-735-4111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d947-724e-8cad-c698a2bc34ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d947-724e-8cad-c698a2bc34ce",
        "storage_key": "property/6767906449167131/019d0215-d947-724e-8cad-c698a2bc34ce.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ873l6bIjoFMR9DCTqA04GWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_9790e019-4cdc-4df6-868b-b9a61b41c629",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Glenrose Rehabilitation Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "10230 111 Ave NW, Edmonton, AB T5G 0B7, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ahs.ca/grh",
      "poi_directions_map_url": "https://maps.google.com/?cid=10533193374000742957&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glenrose-rehabilitation-hospital",
      "poi_latitude": "53.5601974",
      "poi_longitude": "-113.4980058",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 780-735-7999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d947-724e-8cad-c698a2bc34ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d947-724e-8cad-c698a2bc34ce",
        "storage_key": "property/6767906449167131/019d0215-d947-724e-8cad-c698a2bc34ce.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJp-GR3K0joFMRLQLQ_5BrLZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_91bc38dc-72a3-4f41-ae46-5630decd5a49",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Muttart Conservatory",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9626 96a St NW, Edmonton, AB T6C 4L8, Canada",
      "poi_short_description": "Botanical gardens offering glass pyramids with tropical & arid biomes, plus events & courses.",
      "poi_long_description": "Botanical gardens offering glass pyramids with tropical & arid biomes, plus events & courses.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.edmonton.ca/attractions_events/muttart-conservatory.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11696038368296226741&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "muttart-conservatory",
      "poi_latitude": "53.53519989999999",
      "poi_longitude": "-113.4772947",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 780-442-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyMfsEIioFMRtc-ife2sUKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_c76d76e8-1c03-4638-9eb0-227b69dc2a17",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Rundle Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2909 113 Ave NW, Edmonton, AB T5W 0P3, Canada",
      "poi_short_description": "Expansive park with a variety of recreational amenities, multi-use trails, green spaces & lakes.",
      "poi_long_description": "Expansive park with a variety of recreational amenities, multi-use trails, green spaces & lakes.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.edmonton.ca/activities_parks_recreation/parks_rivervalley/rundle-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9355961674800531461&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rundle-park",
      "poi_latitude": "53.5550042",
      "poi_longitude": "-113.3883135",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 780-422-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d997-76b8-84f3-a0ed58ee2082.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d997-76b8-84f3-a0ed58ee2082",
        "storage_key": "property/6767906449167131/019d0215-d997-76b8-84f3-a0ed58ee2082.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJexb5zDA9oFMRBYinvpIN14E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_d5b509d7-1c53-46d0-bf78-a503cfc576fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Churchill Square",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10205 102A Ave NW, Edmonton, AB T5J 3N5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-38f4-7538-b571-2cb961fe4b0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-38f4-7538-b571-2cb961fe4b0d",
        "storage_key": "property/6767906449167131/019d0216-38f4-7538-b571-2cb961fe4b0d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7257785456618195048&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "churchill-square",
      "poi_latitude": "53.5441408",
      "poi_longitude": "-113.4899685",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d997-76b8-84f3-a0ed58ee2082.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d997-76b8-84f3-a0ed58ee2082",
        "storage_key": "property/6767906449167131/019d0215-d997-76b8-84f3-a0ed58ee2082.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnVI_nE8ioFMRaEi5XWvVuGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_19834624-9b86-4a67-ba11-0a4500027eff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Borden Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7507 Borden Park Rd NW, Edmonton, AB T5B 4W8, Canada",
      "poi_short_description": "Leafy community park with flower gardens, playing fields, tennis courts, play areas & picnic areas.",
      "poi_long_description": "Leafy community park with flower gardens, playing fields, tennis courts, play areas & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-3dea-75b8-9113-08203d57879d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-3dea-75b8-9113-08203d57879d",
        "storage_key": "property/6767906449167131/019d0216-3dea-75b8-9113-08203d57879d.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.edmonton.ca/activities_parks_recreation/parks_rivervalley/borden-park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13421457098713786537&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "borden-park",
      "poi_latitude": "53.5635707",
      "poi_longitude": "-113.4524126",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 780-442-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d997-76b8-84f3-a0ed58ee2082.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d997-76b8-84f3-a0ed58ee2082",
        "storage_key": "property/6767906449167131/019d0215-d997-76b8-84f3-a0ed58ee2082.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu5Q5Ah4joFMRqej6EB-YQro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_aa0392ac-0d48-40e4-a557-23a88a981304",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "The Quarry",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "945 167 Ave NE, Edmonton, AB T5Y 0P6, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-3de6-74dd-9273-738118e923a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-3de6-74dd-9273-738118e923a8",
        "storage_key": "property/6767906449167131/019d0216-3de6-74dd-9273-738118e923a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thequarryedmonton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=910201945173695920&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-quarry",
      "poi_latitude": "53.624813",
      "poi_longitude": "-113.3284378",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 780-477-8437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-5933-7317-809a-64c77ef1217d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0216-5933-7317-809a-64c77ef1217d",
        "storage_key": "property/6767906449167131/019d0216-5933-7317-809a-64c77ef1217d.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJEV76cQY8oFMRsJ3yv9ivoQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_7ee95de6-cc85-455f-ad3c-9fff68fa45d3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Clareview",
      "poi_type": "Transportation & Transit",
      "poi_address": "139 Avenue Northeast, Edmonton, AB T5Y 0C5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-b42d-7711-8de5-4d357a604da2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0215-b42d-7711-8de5-4d357a604da2",
        "storage_key": "property/6767906449167131/019d0215-b42d-7711-8de5-4d357a604da2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9672344710029240297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clareview",
      "poi_latitude": "53.6018",
      "poi_longitude": "-113.411376",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHbqZR7w8oFMR6edrekQSO4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_627ea95c-2cc4-4721-932e-0fb6aef0e8bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Churchill Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Edmonton, AB T5J 2V5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-41bb-74aa-a932-68424b83981c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-41bb-74aa-a932-68424b83981c",
        "storage_key": "property/6767906449167131/019d0216-41bb-74aa-a932-68424b83981c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7204538916957850&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "churchill-station",
      "poi_latitude": "53.54376",
      "poi_longitude": "-113.48892",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJddQniU8ioFMRmm7qbn2YGQA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_13c1997e-8431-4dfb-b179-92d2eacdcbd2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Corona",
      "poi_type": "Transportation & Transit",
      "poi_address": "Edmonton, AB T5J 2A7, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-4240-708c-b88f-5e0973d748d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-4240-708c-b88f-5e0973d748d6",
        "storage_key": "property/6767906449167131/019d0216-4240-708c-b88f-5e0973d748d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16994039658849815468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "corona",
      "poi_latitude": "53.5407454",
      "poi_longitude": "-113.5045284",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB2U6ijcioFMRrMukDAj11us",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_2e7af2fc-1b58-481e-9069-983d1d8d7690",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Stadium Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Edmonton, AB T5B 0S5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-463c-716c-8a06-b03d8bbda823.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-463c-716c-8a06-b03d8bbda823",
        "storage_key": "property/6767906449167131/019d0216-463c-716c-8a06-b03d8bbda823.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11323854253747459274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stadium-station",
      "poi_latitude": "53.559923",
      "poi_longitude": "-113.470731",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhx7JEQIjoFMRytTpinJpJp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_71266e2d-19de-4845-8dc9-c64964db436a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Clareview Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Edmonton, AB T5Y 3E8, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16952852154958052721&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clareview-station",
      "poi_latitude": "53.601592",
      "poi_longitude": "-113.411819",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTeOOR7w8oFMRcX39ATehROs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_b1c0ec5f-7baf-4bf3-8af7-84278a873eac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "EPCOR Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10423 101 St NW, Edmonton, AB T5H 0M5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-48d2-775e-9647-fc17569db827.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-48d2-775e-9647-fc17569db827",
        "storage_key": "property/6767906449167131/019d0216-48d2-775e-9647-fc17569db827.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.epcortower.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15804762452549447023&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "epcor-tower",
      "poi_latitude": "53.5475557",
      "poi_longitude": "-113.4926569",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 780-424-1331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTeVCkLsjoFMRby2kn7bLVds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ad894d71-d25e-49ad-bbe0-e137e73c050d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Stantec tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10220 103 Ave NW, Edmonton, AB T5J 0K4, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-4a6b-75ac-9944-e7adc8c672cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-4a6b-75ac-9944-e7adc8c672cc",
        "storage_key": "property/6767906449167131/019d0216-4a6b-75ac-9944-e7adc8c672cc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.stantec.com/en/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3549574156420941501&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stantec-tower",
      "poi_latitude": "53.5448365",
      "poi_longitude": "-113.4964918",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 866-782-6832",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjf_dJkkioFMRvYZgieOeQjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e380704c-7bf4-484d-bc0f-3f74dc13f759",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "Seventh Street Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10030 107 St NW, Edmonton, AB T5J 3E4, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-4a3a-777d-b757-5f58a3f51e8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-4a3a-777d-b757-5f58a3f51e8f",
        "storage_key": "property/6767906449167131/019d0216-4a3a-777d-b757-5f58a3f51e8f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.albertahealthservices.ca/findhealth/facility.aspx?id=1002667",
      "poi_directions_map_url": "https://maps.google.com/?cid=11195047648565720070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "seventh-street-plaza",
      "poi_latitude": "53.5401",
      "poi_longitude": "-113.505144",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 866-227-0842",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLe_XLTgioFMRBvRUwIXMXJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_520558e9-cece-4588-8763-487ff2924803",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "MNP Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10235 101 St NW, Edmonton, AB T5J 3E8, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-4d5d-74fa-b06a-b37532bb52df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-4d5d-74fa-b06a-b37532bb52df",
        "storage_key": "property/6767906449167131/019d0216-4d5d-74fa-b06a-b37532bb52df.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://aspenproperties.ca/properties/edmonton/101-street-tower/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16092707386883968605&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mnp-tower",
      "poi_latitude": "53.5452445",
      "poi_longitude": "-113.4927443",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 780-442-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0cMFE8ioFMRXQ6GBRvIVN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f5ee934c-98e2-4831-aa55-0185c09299bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "poi_name": "EPCOR - Hugh J Bolton Service Centre",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12116 107 St NW, Edmonton, AB T5G 2S7, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-4fd7-72aa-b19f-188f53b95e54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0216-4fd7-72aa-b19f-188f53b95e54",
        "storage_key": "property/6767906449167131/019d0216-4fd7-72aa-b19f-188f53b95e54.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.epcor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17370541661635469813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "epcor---hugh-j-bolton-service-centre",
      "poi_latitude": "53.5753508",
      "poi_longitude": "-113.5067734",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 780-412-4588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0215-d548-7203-b257-434272d41708",
        "storage_key": "property/6767906449167131/019d0215-d548-7203-b257-434272d41708.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz9G1spgjoFMR9eHnsZuPEPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_98b1e9d82668fce1c1af99da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_cc1cc02b097cd5a2cfcd4259",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e26a7a9d1e575cd533e949c9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_be848d87d7064b4c5942d220",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_90b89b0504bb1f0e259ec71d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_63d5ef8b-5baf-44b4-88be-449b098d8b35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "rating": "5.0",
      "name": "Harpreet Kaur",
      "text": "\"I am beyond impressed with the shavia at Wyndham Apartments. She went above and beyond to ensure I found the perfect apartment. After listening to my needs and preferences, she showed me a beautiful new place that checked every box. Her attention to detail, professionalism, and commitment to customer satisfaction made the entire process seamless and stress-free.\n\nNot only did she provide exceptional service, but her friendly and approachable demeanor made me feel truly valued as a tenant. Thanks to her, I now have an amazing new apartment that I’m thrilled to call home.\n\nIf you're looking for a place at Wyndham Apartments, I highly recommend working with her. She’s an absolute gem, and her dedication to ensuring residents are happy is unparalleled!\"",
      "date": "2025-03-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_7e1cf199-4e8f-4958-a43f-566da7ca002a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-beda-75ab-abe9-e03c36513803.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchenette and living area of an apartment.",
        "public_id": "019d0216-beda-75ab-abe9-e03c36513803",
        "storage_key": "property/6767906449167131/019d0216-beda-75ab-abe9-e03c36513803.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Wyndham Crossing | 1 Bedroom | The Argos",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mERuNssmwik"
    },
    {
      "id": "custom_a88b2e75-e68e-4569-9ad0-19c4d2b3e4f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-c6fe-75dd-87f0-701163548557.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen and hallway view",
        "public_id": "019d0216-c6fe-75dd-87f0-701163548557",
        "storage_key": "property/6767906449167131/019d0216-c6fe-75dd-87f0-701163548557.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Wyndham Crossing | 1X1 (Argos) | 615 SQ FT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7aEpVEwpteX"
    },
    {
      "id": "custom_72ae2e77-78eb-4c4c-baf3-f5f467a7b919",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-bedc-74eb-8500-9fc549eb213a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and kitchen area in an apartment",
        "public_id": "019d0216-bedc-74eb-8500-9fc549eb213a",
        "storage_key": "property/6767906449167131/019d0216-bedc-74eb-8500-9fc549eb213a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Wyndham Crossing | 2X1 (The Sand Dollar #2)| 819 SQ FT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=iFS7nFWriK1"
    },
    {
      "id": "custom_1c818d0b-84b8-48b2-a71d-48de92fcac9d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-bed8-7698-a280-8d66dc923f96.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living area with large windows overlooking a snowy landscape, leading to a hallway and a modern kitchen with stainless steel appliances.",
        "public_id": "019d0216-bed8-7698-a280-8d66dc923f96",
        "storage_key": "property/6767906449167131/019d0216-bed8-7698-a280-8d66dc923f96.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Wyndham Crossing | 2X1 (The Sand Dollar #1)| 819 SQ FT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kQQKwCZtUUp"
    },
    {
      "id": "custom_7ba49e0f-60da-414a-91b9-9b94a4b06dbb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0216-bf61-75c8-980b-a92f7b775ee9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen and living area in an apartment.",
        "public_id": "019d0216-bf61-75c8-980b-a92f7b775ee9",
        "storage_key": "property/6767906449167131/019d0216-bf61-75c8-980b-a92f7b775ee9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Wyndham Crossing | 3X1 (The Tradewind) | 977 SQ FT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=xHnr7JVWWRV"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019eb963-4c58-75e9-806c-29227198e10f",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Wyndham Crossing Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-edmonton-ab-wyndham-crossing",
      "search_query": "pet friendly apartments edmonton ab",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Edmonton, AB",
      "h2_subtitle": "Looking for pet-friendly apartments in Edmonton, AB? Wyndham Crossing offers a welcoming environment for you and your furry friends.",
      "page_copy": "At Wyndham Crossing, we understand that pets are family. That's why our pet-friendly apartments in Edmonton, AB, are designed to accommodate both you and your four-legged companions. Nestled in the quaint Sifton Park neighborhood, our community offers the amenities you need to call it home. Enjoy the convenience of energy-efficient appliances, and relax in our indoor saltwater pool. Plus, residents can benefit from an exclusive Shaw Discount of up to 40%.\n\nLiving in our pet-friendly paradise means you're always close to ample green spaces and pet parks in Edmonton. Wyndham Crossing features spacious layouts and practical amenities like linen closets and on-site laundry facilities, making it the ideal choice for both you and your pets. Connect with other pet owners and form a community where all members of the family are welcome.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Edmonton, AB",
      "seo_description": "Discover pet-friendly apartments in Edmonton, AB at Wyndham Crossing, offering amenities for you and your pet. Join our community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "apartments-with-indoor-pool-sifton-park-wyndham-crossing",
      "search_query": "apartments with indoor pool in sifton park",
      "category": "Amenity",
      "h1_title": "Sifton Park Apartments with Indoor Pool",
      "h2_subtitle": "Discover apartments with an indoor pool in Sifton Park. Wyndham Crossing offers luxurious amenities tailored for your lifestyle.",
      "page_copy": "Dive into comfort at Wyndham Crossing, where our apartments with indoor pool in Sifton Park set a new standard for luxury living. After a long day, unwind in our refreshing saltwater pool, providing a year-round oasis for relaxation and rejuvenation. Situated in the peaceful Sifton Park neighborhood, our community combines tranquility with convenience.\n\nOur residents appreciate not just the pool, but also energy-efficient appliances available in select homes, and exclusive discounts like the Shaw Discount up to 40%. With amenities such as spacious linen closets and accessible laundry facilities, Wyndham Crossing makes life in Sifton Park seamless and enjoyable. Explore a comfortable and enriching lifestyle with us!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sifton Park Apartments with Indoor Pool",
      "seo_description": "Enjoy the luxury of an indoor pool at Wyndham Crossing. Discover our Sifton Park apartments with outstanding amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "rentals-with-private-walking-trail-edmonton-wyndham-crossing",
      "search_query": "rentals with private walking trail edmonton",
      "category": "Amenity",
      "h1_title": "Edmonton Rentals with Private Walking Trail",
      "h2_subtitle": "Experience Edmonton rentals with access to private walking trails at Wyndham Crossing. A perfect blend of nature and convenience.",
      "page_copy": "Wyndham Crossing offers a unique living experience with Edmonton rentals that access scenic private walking trails. Enjoy the tranquility of Sifton Park while being surrounded by the vibrant city life. Our community provides residents with access to lush paths perfect for a morning jog or an evening stroll, offering a serene escape right at your doorstep.\n\nBeyond the trails, residents of Wyndham Crossing enjoy an array of amenities like an indoor saltwater pool and energy-efficient appliances in select units. Stay connected with a generous Shaw Discount of up to 40% and make use of our convenient on-site laundry facilities. Life at Wyndham Crossing means enjoying the benefits of nature amidst the comforts of home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Edmonton Rentals with Private Walking Trail",
      "seo_description": "Find rentals in Edmonton with private walking trails at Wyndham Crossing. Enjoy nature and city living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "edmonton-apartments-with-parking-laundry-wyndham-crossing",
      "search_query": "edmonton apartments with parking and laundry",
      "category": "Amenity",
      "h1_title": "Edmonton Apartments with Parking & Laundry",
      "h2_subtitle": "Explore Edmonton apartments with parking and laundry at Wyndham Crossing. Convenience meets comfort in a beautiful setting.",
      "page_copy": "Wyndham Crossing is your destination for Edmonton apartments with parking and laundry facilities. Conveniently located in the serene Sifton Park area, these amenities make daily tasks effortless, allowing you more time to enjoy what matters most. Our dedicated parking spaces ensure you always have a secure spot for your vehicle, while our on-site laundry means you never have to go far to freshen up your wardrobe.\n\nMore than just parking and laundry, Wyndham Crossing offers residents a suite of benefits, including an indoor saltwater pool for ultimate relaxation and energy-efficient appliances in select homes. Take advantage of exclusive offers like our Shaw Discount of up to 40%, and enjoy the spacious storage options found in our linen closets. Wyndham Crossing provides a comfortable and convenient living experience in Edmonton.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Edmonton Apartments with Parking & Laundry",
      "seo_description": "Discover Edmonton apartments that offer parking and laundry facilities at Wyndham Crossing, ensuring ease and comfort in daily living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "24-hour-emergency-maintenance-apartments-edmonton-wyndham-crossing",
      "search_query": "24 hour emergency maintenance apartments edmonton",
      "category": "Amenity",
      "h1_title": "24/7 Emergency Maintenance Apartments",
      "h2_subtitle": "Wyndham Crossing offers Edmonton apartments with 24 hour emergency maintenance. Peace of mind and quality living await you.",
      "page_copy": "At Wyndham Crossing, residents enjoy peace of mind with our 24 hour emergency maintenance support, ensuring that any issues are addressed promptly no matter the time of day. Located in Edmonton's tranquil Sifton Park, our community is committed to providing quality living for all our residents. Whether it's a leaky faucet or an unexpected problem, our maintenance team is always on call to assist.\n\nIn addition to round-the-clock maintenance services, Wyndham Crossing boasts amenities such as an indoor saltwater pool, energy-efficient appliances in select homes, and exclusive discounts like the Shaw Discount up to 40%. Our laundry facilities make daily chores convenient, while spacious linen closets offer ample storage. Wyndham Crossing is the perfect place to settle into a hassle-free lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24/7 Emergency Maintenance Apartments",
      "seo_description": "Find Edmonton apartments with 24 hour emergency maintenance at Wyndham Crossing, providing a worry-free living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-sifton-park-wyndham-crossing",
      "search_query": "1 bedroom apartments sifton park",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Sifton Park",
      "h2_subtitle": "Discover our charming 1 bedroom apartments in Sifton Park at Wyndham Crossing. Ideal for singles or couples seeking comfort and style.",
      "page_copy": "Discover the perfect balance of comfort and style with our 1 bedroom apartments in Sifton Park at Wyndham Crossing. Located in a quaint neighborhood, these apartments offer a tranquil retreat while being close to Edmonton's amenities. Each unit is thoughtfully designed, featuring spacious living areas and modern finishes that cater to both singles and couples.\n\nWyndham Crossing not only provides stylish living spaces but also a range of convenient amenities such as an indoor saltwater pool and energy-efficient appliances available in select settings. Residents also enjoy perks like our exclusive Shaw Discount of up to 40% and easy access to laundry facilities. Embrace a lifestyle of comfort and convenience at Wyndham Crossing in Sifton Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Sifton Park",
      "seo_description": "Explore 1 bedroom apartments in Sifton Park at Wyndham Crossing. Ideal for those seeking a comfortable and convenient living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-edmonton-ab-wyndham-crossing",
      "search_query": "2 bedroom apartments edmonton ab",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Edmonton, AB",
      "h2_subtitle": "Wyndham Crossing offers spacious 2 bedroom apartments in Edmonton, AB. Perfect for families or roommates seeking modern comfort.",
      "page_copy": "Wyndham Crossing proudly presents spacious 2 bedroom apartments in Edmonton, AB. Situated in the peaceful Sifton Park area, our apartments are designed for those who value both comfort and convenience. Each unit features generous living spaces and stylish interiors, making it ideal for families or roommates seeking a modern lifestyle.\n\nBeyond the well-appointed interiors, Wyndham Crossing offers a variety of amenities including an indoor saltwater pool, energy-efficient appliances in select units, and on-site laundry facilities. Residents also benefit from exclusive offers such as a Shaw Discount of up to 40%. With ample parking and a convenient location, Wyndham Crossing provides the ultimate living experience in Edmonton, AB.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Edmonton, AB",
      "seo_description": "Find spacious 2 bedroom apartments in Edmonton, AB at Wyndham Crossing, offering modern living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-t5a-4a7-wyndham-crossing",
      "search_query": "3 bedroom apartments near t5a 4a7",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near T5A 4A7",
      "h2_subtitle": "Discover spacious 3 bedroom apartments near T5A 4A7 at Wyndham Crossing. Perfect for larger households seeking comfort and convenience.",
      "page_copy": "Located conveniently near the T5A 4A7 area, Wyndham Crossing offers spacious 3 bedroom apartments ideal for families or those needing extra room. Situated in the charming Sifton Park neighborhood, these homes strike the perfect balance between modern living and accessibility to local amenities.\n\nOur residents enjoy a host of on-site amenities including an inviting indoor saltwater pool and select homes with energy-efficient appliances. The community is designed to meet your daily needs with convenient laundry facilities and exclusive offers like a Shaw Discount of up to 40%. At Wyndham Crossing, we provide all the essentials for a comfortable and convenient lifestyle tailored to your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near T5A 4A7",
      "seo_description": "Explore 3 bedroom apartments near T5A 4A7 at Wyndham Crossing, where comfort meets convenience in a family-friendly setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "apartments-near-norquest-college-edmonton-wyndham-crossing",
      "search_query": "apartments near norquest college edmonton",
      "category": "School",
      "h1_title": "Apartments Near NorQuest College, Edmonton",
      "h2_subtitle": "Discover convenience at Wyndham Crossing, located near NorQuest College in Edmonton. Ideal for students and professionals alike.",
      "page_copy": "Wyndham Crossing is your haven for convenience and comfort, located just a short distance from NorQuest College in Edmonton. Our well-designed apartments cater to students and professionals, providing modern amenities and a serene environment that makes you feel right at home.\n\nNestled in the serene Sifton Park neighborhood, residents enjoy features such as an indoor saltwater pool and select homes with energy-efficient appliances. Our amenities, which include convenient laundry facilities and an exclusive Shaw Discount of up to 40%, ensure that your daily needs are seamlessly met. Choose Wyndham Crossing for a blend of accessibility and lifestyle, perfect for those studying or working near NorQuest College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near NorQuest College, Edmonton",
      "seo_description": "Find apartments near NorQuest College in Edmonton at Wyndham Crossing, offering convenience and comfort for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "wyndham-crossing-apartments-close-to-macewan-university",
      "search_query": "wyndham crossing apartments close to macewan university",
      "category": "School",
      "h1_title": "Wyndham Crossing Apartments by MacEwan University",
      "h2_subtitle": "Wyndham Crossing offers comfortable living close to MacEwan University. Ideal for students and faculty seeking convenient access.",
      "page_copy": "Located conveniently close to MacEwan University, Wyndham Crossing is an ideal choice for students and faculty looking for comfortable apartments with easy access to campus life. Our modern facilities and tranquil Sifton Park setting provide a peaceful retreat from the bustling city, making it an excellent choice for those who value both proximity and privacy.\n\nOur residents enjoy an array of amenities, including an indoor saltwater pool and energy-efficient appliances in select homes. With on-site laundry facilities and an exclusive Shaw Discount of up to 40%, Wyndham Crossing caters to your lifestyle needs, providing a balanced and lively community environment just minutes from MacEwan University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wyndham Crossing by MacEwan University",
      "seo_description": "Choose Wyndham Crossing, close to MacEwan University, for modern living with top amenities. Perfect for students and faculty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "apartments-near-feltham-centre-cat-edmonton-wyndham-crossing",
      "search_query": "near feltham centre cat apartments edmonton",
      "category": "School",
      "h1_title": "Apartments Near Feltham Centre CAT, Edmonton",
      "h2_subtitle": "Wyndham Crossing offers a prime location near Feltham Centre CAT in Edmonton. Ideal for those seeking nearby accommodation.",
      "page_copy": "Wyndham Crossing presents an excellent living opportunity near the Feltham Centre CAT in Edmonton. Perfectly suited for individuals who seek proximity to this pivotal facility, our community offers a harmonious blend of comfort and convenience in the Sifton Park area.\n\nResidents enjoy modern living spaces accompanied by exclusive amenities such as an indoor saltwater pool and select homes equipped with energy-efficient appliances. Additional conveniences include on-site laundry facilities and an attractive Shaw Discount of up to 40%. Choose Wyndham Crossing for a lifestyle that combines accessibility with the comforts of home, making it a great fit for those who frequent Feltham Centre CAT.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Feltham Centre CAT, Edmonton",
      "seo_description": "Discover convenient living near Feltham Centre CAT, Edmonton at Wyndham Crossing, offering excellent amenities and proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "apartments-near-concordia-university-sifton-park",
      "search_query": "apartments near concordia university sifton park",
      "category": "School",
      "h1_title": "Apartments Near Concordia University, Sifton Park",
      "h2_subtitle": "Discover Wyndham Crossing, an ideal choice located near Concordia University in the Sifton Park neighborhood. Perfect for students and academics.",
      "page_copy": "Wyndham Crossing provides the perfect accommodations for those looking to stay close to Concordia University in Edmonton's Sifton Park neighborhood. With its strategic location, residents enjoy easy access to the university while living in a peaceful and well-equipped community.\n\nThis welcoming community boasts an indoor saltwater pool, energy-efficient appliances in select homes, and convenient laundry facilities, catering to students' and academics' busy lifestyles. Plus, with a special Shaw Discount of up to 40%, Wyndham Crossing ensures an economical yet comfortable living experience, making it the top choice for anyone wanting proximity to Concordia University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Concordia University, Sifton Park",
      "seo_description": "Find the ideal apartment near Concordia University at Wyndham Crossing, conveniently located in Sifton Park with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "apartments-near-glenrose-rehabilitation-hospital-edmonton",
      "search_query": "apartments near Glenrose Rehabilitation Hospital Edmonton",
      "category": "Hospital",
      "h1_title": "Apartments Near Glenrose Rehabilitation Hospital",
      "h2_subtitle": "Wyndham Crossing offers convenient living near the Glenrose Rehabilitation Hospital in Edmonton. Ideal for healthcare workers and visitors.",
      "page_copy": "Wyndham Crossing provides a superb living option for those seeking proximity to Glenrose Rehabilitation Hospital in Edmonton. The convenient location in Sifton Park makes it ideal for healthcare professionals and visitors who need easy access to the hospital.\n\nOur community offers a variety of amenities that cater to your needs, including an indoor saltwater pool and energy-efficient appliances in select homes. Residents also benefit from on-site laundry facilities and an exclusive Shaw Discount of up to 40%. Choose Wyndham Crossing for comfortable living that combines accessibility with a range of features designed for modern lifestyles, just minutes from Glenrose Rehabilitation Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Glenrose Rehabilitation Hospital",
      "seo_description": "Choose Wyndham Crossing for modern, convenient living near Glenrose Rehabilitation Hospital, Edmonton. Ideal for professionals and visitors.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "apartments-near-muttart-conservatory-edmonton-wyndham",
      "search_query": "apartments near muttart conservatory edmonton",
      "category": "Park",
      "h1_title": "Apartments Near Muttart Conservatory, Edmonton",
      "h2_subtitle": "Explore Wyndham Crossing, the ideal choice for those looking to live near the Muttart Conservatory in Edmonton. Perfect for nature enthusiasts.",
      "page_copy": "Wyndham Crossing offers an exceptional living opportunity for individuals who wish to reside near the renowned Muttart Conservatory in Edmonton. Located in the scenic Sifton Park neighborhood, this community offers residents the perfect mix of natural beauty and urban convenience.\n\nExperience comfortable living with amenities such as an indoor saltwater pool, energy-efficient appliances in select homes, and on-site laundry facilities. Take advantage of the exclusive Shaw Discount, offering savings of up to 40%. Wyndham Crossing provides a harmonious blend of nature and city living, making it the ideal choice for anyone who treasures proximity to the lush landscapes of the Muttart Conservatory.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Muttart Conservatory, Edmonton",
      "seo_description": "Find your perfect apartment at Wyndham Crossing near Muttart Conservatory, Edmonton. Enjoy modern amenities in a beautiful location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "wyndham-crossing-close-to-churchill-square-edmonton-ab",
      "search_query": "wyndham crossing close to churchill square edmonton ab",
      "category": "Park",
      "h1_title": "Wyndham Crossing Near Churchill Square",
      "h2_subtitle": "Experience the vibrant life near Churchill Square at Wyndham Crossing. Perfectly situated in Edmonton, AB, offering easy access to downtown attractions.",
      "page_copy": "Wyndham Crossing is ideally located for those who wish to be near the bustling heart of Edmonton, within easy reach of Churchill Square. Nestled in the tranquil Sifton Park neighborhood, our community provides a calming retreat from the vibrant downtown energy, while still offering convenient access to all of its attractions.\n\nResidents at Wyndham Crossing can enjoy a range of amenities, such as an indoor saltwater pool, energy-efficient appliances available in select homes, and laundry facilities on-site. Additionally, our exclusive Shaw Discount provides a great deal on connectivity. Experience the best of Edmonton living at Wyndham Crossing, where urban excitement meets home comfort, just a short distance from Churchill Square.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wyndham Crossing Near Churchill Square, Edmonton",
      "seo_description": "Live close to Churchill Square at Wyndham Crossing in Edmonton, AB. Enjoy a modern lifestyle with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "borden-park-edmonton-nearby-apartments-wyndham-crossing",
      "search_query": "borden park edmonton nearby apartments",
      "category": "Park",
      "h1_title": "Borden Park Edmonton Nearby Apartments",
      "h2_subtitle": "Discover Wyndham Crossing, perfect for those looking for apartments near Borden Park in Edmonton. Experience comfortable living in a prime location.",
      "page_copy": "Wyndham Crossing offers a perfect solution for those seeking apartments near Borden Park in Edmonton. Located in the peaceful Sifton Park neighborhood, our community provides residents with the best of both nature and urban living, just a short distance from the lush landscapes of Borden Park.\n\nEnjoy a modern lifestyle with amenities such as an indoor saltwater pool and energy-efficient appliances in select homes. Convenient laundry facilities and an exclusive Shaw Discount make living here even better. Wyndham Crossing combines outstanding facilities and a prime location, making it an excellent choice for those who love being close to nature but still value city conveniences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Borden Park Edmonton",
      "seo_description": "Explore Wyndham Crossing, offering comfortable living near Borden Park in Edmonton. Enjoy great amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "apartments-near-clareview-edmonton-wyndham",
      "search_query": "apartments near Clareview Edmonton",
      "category": "Transit",
      "h1_title": "Apartments Near Clareview, Edmonton",
      "h2_subtitle": "Choose Wyndham Crossing for your apartment needs near Clareview in Edmonton. Enjoy modern conveniences in a serene setting.",
      "page_copy": "Situated close to the bustling area of Clareview, Wyndham Crossing offers an ideal living space for those seeking apartments in a prime Edmonton location. Our community is nestled in the serene Sifton Park neighborhood, providing a peaceful retreat while still being near all the vibrant activities Clareview offers.\n\nResidents can indulge in a range of amenities including an indoor saltwater pool and convenient on-site laundry facilities. Select homes feature energy-efficient appliances, adding modern comfort to your living experience. With an exclusive Shaw Discount, Wyndham Crossing ensures residents enjoy connectivity and savings, making it the perfect choice for easy, comfortable living near Clareview.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Apartments Near Clareview, Edmonton",
      "seo_description": "Discover Wyndham Crossing, offering stylish apartments near Clareview, Edmonton. Enjoy excellent amenities in a tranquil setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "churchill-station-apartments-sifton-park-wyndham",
      "search_query": "Churchill Station apartments Sifton Park",
      "category": "Transit",
      "h1_title": "Churchill Station Apartments in Sifton Park",
      "h2_subtitle": "Explore Wyndham Crossing, offering comfortable and convenient living near Churchill Station in Sifton Park, Edmonton.",
      "page_copy": "Wyndham Crossing is a top choice for those looking for Churchill Station apartments nestled in the quiet Sifton Park neighborhood. Our community offers the perfect blend of tranquility and accessibility, providing easy commuting options with nearby public transportation from Churchill Station.\n\nAt Wyndham Crossing, residents have access to an array of amenities such as an indoor saltwater pool, laundry facilities, and energy-efficient appliances available in some homes. Plus, our exclusive Shaw Discount ensures savings on connectivity. Enjoy the peaceful surroundings of Sifton Park while remaining conveniently connected to the vibrant energy of downtown Edmonton via Churchill Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Churchill Station Apartments, Sifton Park",
      "seo_description": "Discover Wyndham Crossing in Sifton Park, offering modern apartments with easy access to Churchill Station in Edmonton.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "corona-transit-apartments-edmonton-wyndham-crossing",
      "search_query": "Corona transit apartments Edmonton",
      "category": "Transit",
      "h1_title": "Corona Transit Apartments in Edmonton",
      "h2_subtitle": "Wyndham Crossing offers excellent apartment living with convenient access to Corona transit in Edmonton, perfect for comfortable urban living.",
      "page_copy": "Looking for Corona transit apartments in Edmonton? Wyndham Crossing offers the perfect blend of comfort and convenience with easy access to the Corona transit system. Located in the serene neighborhood of Sifton Park, our community is ideal for those who seek a peaceful home with seamless connectivity to the heart of the city.\n\nEnjoy our array of amenities, including an indoor saltwater pool and laundry facilities, perfect for modern living. In select homes, energy-efficient appliances add to the convenience, while an exclusive Shaw Discount ensures excellent value. Choose Wyndham Crossing to enjoy a lifestyle that combines comfort with the ease of a quick commute via Corona transit.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Corona Transit Apartments, Edmonton",
      "seo_description": "Discover Wyndham Crossing, offering modern apartments with convenient access to Corona transit in Edmonton's Sifton Park area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "stadium-station-nearby-apartments-ab-wyndham",
      "search_query": "Stadium Station nearby apartments AB",
      "category": "Transit",
      "h1_title": "Stadium Station Nearby Apartments in AB",
      "h2_subtitle": "Experience living at Wyndham Crossing, where modern amenities meet convenience with Stadium Station apartments nearby in AB.",
      "page_copy": "Wyndham Crossing is a prime choice for those searching for Stadium Station nearby apartments in AB. Located in the tranquil yet conveniently situated neighborhood of Sifton Park, our community provides effortless access to public transit, making commuting via Stadium Station a breeze.\n\nOur residents enjoy a variety of amenities, such as an indoor saltwater pool and on-site laundry facilities that cater to modern, urban lifestyles. Select apartments feature energy-efficient appliances for enhanced living. Additionally, take advantage of our exclusive Shaw Discount to enjoy significant savings. Choose Wyndham Crossing for a harmonious blend of comfort, convenience, and community connection near Stadium Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stadium Station Nearby Apartments, AB",
      "seo_description": "Discover Wyndham Crossing in AB, offering modern and convenient apartments near Stadium Station with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167131",
      "source": "generator",
      "page_item_url": "wyndham-crossing-near-clareview-station-t5a",
      "search_query": "Wyndham Crossing near Clareview Station T5A",
      "category": "Transit",
      "h1_title": "Wyndham Crossing Near Clareview Station T5A",
      "h2_subtitle": "Discover the convenience of living at Wyndham Crossing, located near Clareview Station in the T5A area for easy commuting and modern amenities.",
      "page_copy": "Located in Edmonton's peaceful Sifton Park neighborhood, Wyndham Crossing offers outstanding living at an enviable location near Clareview Station in the T5A area. With such proximity, commuting is seamless, whether you're heading downtown or exploring the greater Edmonton area.\n\nOur community boasts amenities tailored for comfort and convenience, including an indoor saltwater pool, and on-site laundry facilities. Select homes are equipped with energy-efficient appliances, providing contemporary living standards. An exclusive Shaw Discount further enhances value for our residents. Embrace the ideal lifestyle at Wyndham Crossing, where urban accessibility and residential tranquility merge near Clareview Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a paved walkway and grassy lawn.",
        "public_id": "019d0215-3f4d-7711-81be-e25226cd3251",
        "storage_key": "property/6767906449167131/019d0215-3f4d-7711-81be-e25226cd3251.webp",
        "width": 1024,
        "height": 684
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wyndham Crossing Near Clareview Station, T5A",
      "seo_description": "Explore Wyndham Crossing in Edmonton's T5A, offering modern living with easy access to Clareview Station and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11308871617"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7808519342"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N4NWHC6K"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 5"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "b21902a3-3569-41cb-a319-988b6749e569"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Vantage"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/cc9302f8-33e2-4f86-a32d-616dc9f5ce8c/app.js?property=cc9302f8-33e2-4f86-a32d-616dc9f5ce8c&propertyName=Wyndham+Crossing&channelUuid=c249095b-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47723982653"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkEzSm1IMEdwR2dTU1d3clY2RmlqWVE9PSIsInZhbHVlIjoiOFo3dVYwUmpKWEFkNVVHMG0rNTBVZz09IiwibWFjIjoiYTViODg0ZDcwMzQzMmExMGQ1OWM2MTczYTJkMTg4ZmZhNzEzMmI2NmUwOTZkY2EwODQ3NzNlYjQwOTFlOTBjMiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11308871617",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7808519342",
  "custom_google_gtm_id": "GTM-N4NWHC6K",
  "custom_rollout_phase": "Phase 5",
  "custom_rentgrata_token": "b21902a3-3569-41cb-a319-988b6749e569",
  "custom_vibesites_theme": "Vantage",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/cc9302f8-33e2-4f86-a32d-616dc9f5ce8c/app.js?property=cc9302f8-33e2-4f86-a32d-616dc9f5ce8c&propertyName=Wyndham+Crossing&channelUuid=c249095b-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47723982653",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkEzSm1IMEdwR2dTU1d3clY2RmlqWVE9PSIsInZhbHVlIjoiOFo3dVYwUmpKWEFkNVVHMG0rNTBVZz09IiwibWFjIjoiYTViODg0ZDcwMzQzMmExMGQ1OWM2MTczYTJkMTg4ZmZhNzEzMmI2NmUwOTZkY2EwODQ3NzNlYjQwOTFlOTBjMiJ9",
  "custom_audioeye_site_id": "a9e837f9-1210-40d5-9865-32de2885342d",
  "custom_audioeye_site_hash": "f28fb9d40cc02b8fd356cc9a15e06a68"
};

export const generatedAt = '2026-10-27T17:09:21.625Z';
